import type { Resolvers } from '../generated/server/resolvers'
import request from '../requesters/default.ts'

const VulnerabilityResolvers: Resolvers = {
  Query: {
    vulnerabilityTemplates: async (_parent, { provider }) => {
      const response = await request.get<VulnerabilityTemplateResponse>(
        `/checks-service/vulnerability/templates${provider ? '/provider?provider=' + provider : ''}`,
      )
      return response.data
    },
    vulnerabilityReport: async (_parent, { assessment_uuid, client }) => {
      const response = await request.get<VulnerabilityReport>(
        `/checks-service/vulnerability/report?assessment_uuid=${assessment_uuid}&client=${client}`,
      )
      return response.data
    },
  },
  Mutation: {
    createVulnerabilityAssessments: async (_parent, { caseID }) => {
      const response = await request.post<VulnerabilityResponse>(
        `/checks-service/vulnerability/assessments?case=${caseID}`,
      )
      return response.data
    },
  },
}

export default VulnerabilityResolvers
